<template>
  <div class="billings-list">
    <InvoiceDataModal ref="invoiceDataModal" />

    <div
      v-if="isLoadingBillings || isDoingDownloading"
      class="billings-list__loading"
    >
      <Spinner />
    </div>

    <div v-else>
      <div
        v-if="billingsList && billingsList.length"
        class="billings-list__table"
      >
        <div class="table-header">
          <ul>
            <li class="--date">
              Mês Referência
            </li>
            <li class="--period">
              Período
            </li>
            <li class="--demonstrative">
              Demonstrativo
            </li>
            <li class="--download" />
          </ul>
        </div>
        <div
          v-for="(invoice, index) in billingsList"
          :key="index"
          class="table-body"
          :class="{ active: activeItem === index }"
        >
          <div
            class="content"
            @click="setItemOpened(index)"
          >
            <p class="--date">
              {{ invoice.invoiceDate }}
            </p>
            <p class="--period">
              {{ invoice.invoicePeriod }}
            </p>
            <p class="--demonstrative">
              {{ invoice.demonstrative }}
            </p>
            <div class="--download">
              <div class="box-download">
                <div
                  class="status-icon icon-download-pdf"
                  @click="download(invoice.invoiceNumber, 'pdf', $event)"
                />
                <div
                  v-if="invoice.invoiceCSV"
                  class="status-icon icon-download-csv"
                  @click="download(invoice.invoiceNumber, 'csv', $event)"
                />
                <div
                  v-if="invoice.invoiceXML"
                  class="status-icon icon-download-xml"
                  @click="download(invoice.invoiceNumber, 'xml', $event)"
                />
              </div>
              <svg-loader src="/static/images/arrow-up.svg" />
            </div>
          </div>
          <div class="billings-list__sub-table">
            <div class="sub-table-content head">
              <p>N. da nota</p>
              <p>Valor</p>
              <p>Vencimento</p>
              <p class="--ticket-number">
                N. do Boleto
              </p>
              <p>{{ toggle.prePaid ? 'Nfe' : 'Nfe / Boleto' }}</p>
            </div>
            <hr>
            <div
              v-for="(data, i) in invoice.items"
              :key="i"
            >
              <div class="sub-table-content">
                <p>{{ data.noteNumber }}</p>
                <p>{{ price(data.value) }}</p>
                <p>{{ data.pay }}</p>
                <p class="--ticket-number">
                  {{ data.ticketNumber }}
                </p>
                <div class="--download">
                  <div
                    v-if="data.noteNumber"
                    class="status-icon icon-nfe"
                    @click="downloadNote(data)"
                  />
                  <div
                    v-if="data.ticketNumber"
                    class="status-icon icon-bill"
                    @click="downloadTicket(data.ticketNumber)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="empty-list"
      >
        <img
          src="/static/images/empty-list.svg"
          alt="Lista Vazia de faturas"
        >
        Ainda não há Faturas pra serem visualizadas
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { justDownloadBase64File } from '@/utils/convertBase64ToFile'
import { formatPrice } from '@/utils/formatPrice'

import billings from '@/api/billings'
import notify from '@/api/notification'

import Spinner from '@/components/common/Spinner'
import InvoiceDataModal from '@/components/Invoicing/components/InvoiceDataModal.vue'

export default {
  name: 'BillingsList',
  components: {
    Spinner,
    InvoiceDataModal
  },
  data() {
    return {
      activeItem: null,
      currentPage: 0,
      isDoingDownloading: false
    }
  },
  computed: {
    ...mapGetters(['billingsList', 'isLoadingBillings', 'billingsTotalPages', 'toggle'])
  },
  created() {
    this.loadMore(this.currentPage)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions(['getInvoiceList']),
    price(value) {
      if (!isNaN(value)) {
        return `R$ ${formatPrice(value)}`
      }
      return ''
    },
    setItemOpened(index) {
      if (this.activeItem === index) {
        return (this.activeItem = null)
      }
      return (this.activeItem = index)
    },
    download(number, type, event) {
      this.isDoingDownloading = true
      event.stopPropagation()

      let typeDownload = ''
      if (type === 'csv') {
        typeDownload = 'CSV'
      } else if (type === 'pdf') {
        typeDownload = 'Pdf'
      } else if (type === 'xml') {
        typeDownload = 'XML'
      }

      const data = { number: number, type: typeDownload }

      billings
        .downloadInvoice(data)
        .then(res => {
          justDownloadBase64File(`application/${type}`, res.data.base64, `fatura_${res.data.invoiceNumber}.${type}`)
          this.isDoingDownloading = false
        })
        .catch(err => {
          this.isDoingDownloading = false
          notify({
            title: 'AVISO: ',
            message: 'Ocorreu um erro ao baixar a fatura.'
          })
          console.error(err)
        })
    },
    downloadNote(noteData) {
      this.$refs.invoiceDataModal.openInvoiceDataModal(noteData)
    },
    downloadTicket(ticketNumber) {
      const walletType = this.toggle.prePaid ? 'PREPAID' : 'POSTPAID'

      billings
        .getTicketData(ticketNumber, walletType)
        .then(res => {
          window.open(
            `https://www63.bb.com.br/portalbb/boleto/boletos/hc21e,802,3322,10343,2,0,1.bbx?lnDigtvl=${res.data.ticketNumberNotVerifyDigit}&cpfCnpjPagador=${res.data.withdrawnCNPJ}&cpfCnpjbeneficiario=${res.data.assignorCNPJ}`,
            '_blank'
          )
        })
        .catch(err => {
          notify({
            title: 'AVISO: ',
            message: 'Erro ao carregar o boleto.'
          })
          console.error(err)
        })
    },
    handleScroll() {
      const scrollPosition = window.scrollY + window.innerHeight
      const pageHeight = document.documentElement.scrollHeight
      if (scrollPosition >= pageHeight) {
        this.loadMore(this.currentPage)
      }
    },
    loadMore() {
      if (this.currentPage < this.billingsTotalPages) {
        this.getInvoiceList(this.currentPage).then(() => {
          if (this.billingsList.length) {
            this.currentPage++
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .billings-list {
    &__loading {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__table {
      margin-top: 30px;

      .table-header {
        padding: 6px 26px 6px 24px;

        ul {
          display: flex;
          align-items: center;

          li {
            margin: 0;
            font-weight: 600;
            font-size: 11.11px;
            text-transform: uppercase;
            color: #999999;
          }
        }
      }

      .table-body {
        background-color: #fff;
        border-radius: 6px;
        margin-bottom: 12px;
        border-left: 6px #fff solid;

        &:hover {
          border-color: #7f1a54;
        }

        &.active {
          padding: 0 16px 10px 10px;

          .content {
            padding: 10px 8px 5px;
            margin-bottom: 8px;

            .--download .md-icon {
              transform: rotate(0deg);
            }
          }

          .billings-list__sub-table {
            opacity: 1;
            max-height: fit-content;

            .sub-table-content {
              display: flex;
            }
          }
        }

        .content {
          display: flex;
          align-items: center;
          font-weight: 400;
          margin-bottom: 0;
          padding: 10px 24px 10px 18px;
          cursor: pointer;

          p {
            font-size: 14px;
            color: #363636;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .--download {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .md-icon {
              margin: 0;
              transform: rotate(180deg);
              transition: all 0.2s ease-in;
            }

            .box-download {
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .status-icon {
              margin: 0 3px;
            }
          }
        }

        hr {
          height: 1px;
          border: none;
          background: #fff;
        }
      }

      .--period {
        flex: 2;
      }

      .--date,
      .--demonstrative,
      .--download {
        flex: 1;
      }
    }

    &__sub-table {
      max-height: 0;
      opacity: 0;

      .sub-table-content {
        display: none;
        padding: 10px;
        background-color: rgb(232, 232, 232);

        &.head {
          p {
            font-weight: 600;
            text-transform: uppercase;
            font-size: 11px;
          }
        }

        p {
          flex: 1;

          &.--ticket-number {
            flex: 2;
          }
        }
      }
    }

    .content {
      p {
        font-size: 13.33px;
      }
    }
  }
</style>
